// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

import BroadcastCanvas from "./broadcast/BroadcastCanvas";
import BroadcastOverlayView from "./broadcast/BroadcastOverlayView";
import { buildLiveOverlayView } from "./broadcast/overlayView";
import type { StreamingDisplayState } from "./StreamingLiveClient";

// Overlay de transmisión: header con torneo y sponsors, franja inferior con el atleta, lo levantado en el
// torneo, el total, las luces y el reloj. Todo sale de lo que publica el operador por el live.
const BroadcastOverlay = (state: StreamingDisplayState) => (
  <BroadcastCanvas label="Broadcast Overlay Display">
    <BroadcastOverlayView view={buildLiveOverlayView(state)} sponsors={state.broadcast.sponsors ?? []} />
  </BroadcastCanvas>
);

export default BroadcastOverlay;
